import { createElement } from "react";
import type { AppRoute } from "@routes/types";
import AppShellLayout from "@components/ui/layout/AppShellLayout";
import type { RouteObject } from "react-router-dom";
import { OFFER_APPLICANT_CREATE_PATH } from "@routes/path";
import ApplyOfferApplicant from "@pages/offer-applicant/create";

const routes: AppRoute[] = [
    {
        path: OFFER_APPLICANT_CREATE_PATH,
        element: createElement(ApplyOfferApplicant),
        label: "Apply for Offer",
    }
];

const OfferApplicantRoute: RouteObject[] = [{
                element: createElement(AppShellLayout),
                children: routes
            }];

export default OfferApplicantRoute;